;(function () {
  angular
    .module('contrast.thermometer-filter')
    .filter('truncateFilterPercent', function () {
      return function (input) {
        if (angular.isNumber(input)) {
          if (input < 1) {
            input = '<1'
          } else {
            input = Math.round(input)
          }
        }
        return input + '%'
      }
    })
})()
